/**
 * Anchor Links — view script.
 *
 * Handles active-state toggling when a link is clicked.
 * The server-rendered active state (sol-anchor-links__link--active) is used as
 * the initial state; clicking any link within the block transfers the modifier
 * to the clicked item.
 */

document.addEventListener( 'DOMContentLoaded', () => {
	const blocks = document.querySelectorAll( '.sol-anchor-links' );

	if ( ! blocks.length ) {
		return;
	}

	blocks.forEach( block => {
		const links = block.querySelectorAll( '.sol-anchor-links__link' );

		links.forEach( link => {
			link.addEventListener( 'click', () => {
				links.forEach( l => l.classList.remove( 'sol-anchor-links__link--active' ) );
				link.classList.add( 'sol-anchor-links__link--active' );
			} );
		} );
	} );
} );
